import {RouterProvider} from 'react-router-dom';

// project imports
import router from './routes';
import ThemeCustomization from './themes';

import ScrollTop from './components/ScrollTop';
import {Provider} from "react-redux";
import store from "./store/store";
import { AuthProvider } from './contexts/AuthContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
    return (
        <ThemeCustomization>
            <Provider store={store}>
                <AuthProvider>
                    <ScrollTop>
                        <RouterProvider router={router}/>
                    </ScrollTop>
                </AuthProvider>
            </Provider>
        </ThemeCustomization>
    );
}
